import { useMutation } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { TARGET_PROPERTIES } from '../../flows/transactions/constants';

const {
  CONTROLLERS: {
    COMMENT: { VERSION, BASE },
  },
} = USER;

export const useUploadCommentMutation = ({
  customerId,
  transactionId,
  handleOnSuccessUpload,
  note,
  isExternal,
  accountExternalId,
  externalAccountId,
}: {
  customerId: string;
  transactionId: string;
  handleOnSuccessUpload?: (value: string, property: string) => void;
  note: string;
  isExternal?: boolean;
  accountExternalId?: string;
  externalAccountId?: string;
}) =>
  useMutation(
    async () => {
      const url = isExternal
        ? `${BASE_URL}/api/v1/user/${customerId}/account/${accountExternalId}/externalAccount/${externalAccountId}/transaction/${transactionId}/comment`
        : `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}/${transactionId}/comment`;
      await httpService.post(url, {
        note,
      });
    },
    {
      onSuccess: () => {
        if (handleOnSuccessUpload) {
          handleOnSuccessUpload(note, TARGET_PROPERTIES.COMMENT);
        }
      },
    },
  );
